import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-payment-definitions',
    imports: [RouterOutlet],
    template: ` <router-outlet></router-outlet> `
})
export class PaymentDefinitionsComponent {}
